import React from 'react'
import { ActivityStatus } from '@/pages/communal/statistics/components/common/data'
import { ActivityStatusChart } from './ActivityStatusChart'
import { HelpPopupButton } from '@/popups/helppopup/help'
import { Services } from '@/services/services'
import { CurrentSession } from '@/services/repository/session'
import { useTranslations } from '@/hooks/useTranslations'

type ActivityStatusBoxProps = {
  services: Services
  session: CurrentSession
  activityStatus: ActivityStatus
}

export const ActivityStatusBox = ({ services, session, activityStatus }: ActivityStatusBoxProps) => {
  const translates = useTranslations(services, session)

  if (translates === undefined) {
    return <div className='spinner'></div>
  }

  return (
    <div>
      <HelpPopupButton helpKey='page.statistics.global.box.activitystatus.help' translates={translates}/>
      <ActivityStatusChart
        activityStatus={activityStatus}
        chartTitle={translates.for('page.statistics.global.box.activitystatus.title')}
        translationsKey='page.statistics.global.box.activitystatus.data_label'
        translates={translates}
      />
    </div>
  )
}